import { SkeletonBox, SkeletonCircle } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from './styles'

export const OrganizationDropdownSkeleton = (): ReactElement => (
  <Styled.Wrapper>
    <SkeletonBox width={32} height={32} data-testid="avatar-org-skeleton" />
    <Styled.TextContent>
      <SkeletonBox height={8} width={120} data-testid="name-org-skeleton" />
      <SkeletonBox height={8} width={120} data-testid="user-org-skeleton" />
    </Styled.TextContent>
    <SkeletonCircle size={16} data-testid="icon-org-skeleton" />
  </Styled.Wrapper>
)
